import { useStateValue } from '../context/StateValueContext';

export const HasPermission = ({ 
  permission, 
  children,
  adminCompany,
}: { 
  permission?: string | string[],
  children: React.ReactNode,
  adminCompany?: boolean,
}) => {
  // Context hook must be used inside a React component
  // So this implementation is for reference, not to be called outside a component
  const [{ user }] = useStateValue();
  
  if (!user) {
    return null;
  }

  if (adminCompany) {
    return user.companyId === 1 ? children : null;
  }

  if (permission) {
    if (!user.permissions || !Array.isArray(user.permissions)) {
      return null;
    }
    // Array = any-of, mirroring Protected and AppSidebar's matchesPermission.
    const required = Array.isArray(permission) ? permission : [permission];
    return required.some((p) => user.permissions.includes(p)) ? children : null;
  }
  
  return null;
};
